import { Timestamp } from "firebase-admin/firestore";
import { IAuditLog, IDeprecatedFiling, IEntityDetails, IFiling, Modify } from "../../../src/app/core/interfaces";
import { IDeprecatedEntityCf, IEntityCf } from "./entity-interfaces";
import { IOwnerCf } from "./owner-interfaces";

export type IFilingCf = Modify<IFiling, {
  snapshotDate: Timestamp;
  entitySnapshot: IEntityCf;
  entityOwnersSnapshot: IOwnerCf[];
}>;

/** @deprecated */
export type IDeprecatedFilingCf = Modify<IDeprecatedFiling, {
  snapshotDate: Timestamp;
  entitySnapshot: IDeprecatedEntityCf;
}>;

/**
* Checks if a filing is of the deprecated type.
* 
* @deprecated Use isFilingCf instead for new Filings
* 
* @param {IFilingCf | IDeprecatedFilingCf} filing - The filing to check
* @return {boolean} Returns true if the filing is deprecated (doesn't have entityOwnersSnapshot)
*/
export const isFilingCfDeprecated = (
  filing: IFilingCf | IDeprecatedFilingCf
): filing is IDeprecatedFilingCf => !filing.entityOwnersSnapshot;

export const isFilingCf= (
  filing: IFilingCf | IDeprecatedFilingCf
): filing is IFilingCf => !!filing.entityOwnersSnapshot;

export type IAuditLogCf = Modify<IAuditLog, {
  date: Timestamp;
}>;

export type IEntityDetailsCf = Modify<IEntityDetails, {
  filings: (IFilingCf | IDeprecatedFilingCf)[];
  auditLog: IAuditLogCf[];
}>;
